


import { setGetMailingStatisticsScrollerUsersTransactionsByUserAction } from '../action';
import { getMailingStatisticsScrollerUsersDepositsByUser } from '../api/getMailingStatisticsScrollerUsersDepositsByUser';

export const setGetMailingStatisticsScrollerUsersTransactionsByUser = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await getMailingStatisticsScrollerUsersDepositsByUser({
                ...params,
                status: 'ready_for_pay'
            });
            const state = getState().mailing.scrollers.transactions_by_user;

            const new_data = {
                ...state,
                [params.login]: data
            }
            dispatch(setGetMailingStatisticsScrollerUsersTransactionsByUserAction(new_data))
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}